import {Alert, Box, Button, Container, FormControl, FormLabel, Input} from "@mui/joy";
import {BmeShop} from "../BmeShop";
import useUser from "../useUser";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import useToken from "../useToken";

export default function Login() {
    const navigate = useNavigate();

    const [, setToken] = useToken();
    const [user] = useUser();

    const [alert, setAlert] = useState("");

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [loading, setLoading] = useState(false);

    const requestLogin = () => {
        if (email.length > 0 && password.length > 0) {
            (async () => {
                setLoading(true);

                await BmeShop.account.login(email, password)
                    .then((data) => {
                        setToken(data.account.token);
                        window.location.reload();
                    })
                    .catch((err) => setAlert(err.message));

                setLoading(false);
            })();
        }

        return false;
    };

    useEffect(() => {
        if (user && user.username) {
            navigate('/');
        }
    }, [user, navigate]);

    return (
        <Container
            sx={{
                width: '350px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100vh',
            }}
        >
            {alert &&
                <Alert
                    color="danger"
                    sx={{
                        mb: '20px',
                    }}
                >
                    {alert}
                </Alert>
            }

            <FormControl sx={{ mb: '25px' }}>
                <FormLabel>
                    Email
                </FormLabel>
                <Input
                    placeholder="gburdell@gatech.edu"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </FormControl>

            <FormControl sx={{ mb: '40px' }}>
                <FormLabel>
                    Password
                </FormLabel>
                <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </FormControl>

            <Button
                onClick={requestLogin}
            >
                Login
            </Button>

            <Box
                sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, color: '#fff', zIndex: 100, display: loading ? 'block' : 'none' }}
                open={loading}
            >
            </Box>
        </Container>
    );
}